import { CheckRounded } from '@mui/icons-material';
import Button from '@mui/material/Button';

export const FeedbackAddedToCollectionIndicator = () => {
  return (
    <Button variant="text" color="success" startIcon={<CheckRounded />}>
      Added
    </Button>
  );
};
